import Bry from '@/helpers/Bry'

// getCertificate no vuex para não precisar ficar
// importando a classe da Bry toda vez

// Obs: a chamada deve ser assíncrona
// ex: await this.$store.dispatch('bry/getCertificate')
export default {
  namespaced: true,
  actions: {
    async getCertificate () {
      const certificate = Bry.getCertificate()

      return certificate
    }
  }
}
